const { fetchUserMenus } = await import('@/api/system/user')

const state = {
  menus: [], // 菜单列表
  homeQuickEntries: [] // 首页快捷入口
}

const mutations = {
  SET_MENUS: (state, menus) => {
    state.menus = menus
  },
  SET_HOME_QUICK_ENTRIES: (state, quickEntries) => {
    state.homeQuickEntries = quickEntries
  }
}

const actions = {
  setMenus({ commit }, menus) {
    commit('SET_MENUS', menus)
  },

  async fetchMenus({ commit }) {
    try {
      const response = await fetchUserMenus({})
      // 过滤只显示 is_visible 等于 1 的菜单
      const allMenus = response.data.menus || response.data.list || []
      
      const quickEntries = []
      const visibleMenus = filterVisibleMenus(allMenus, quickEntries)
      
      commit('SET_MENUS', visibleMenus)
      commit('SET_HOME_QUICK_ENTRIES', quickEntries)

      return Promise.resolve(response)
    } catch (error) {
      console.error('Failed to fetch menus:', error)
      return Promise.reject(error)
    }
  },

  // 刷新菜单 - 供其他页面调用
  async refreshMenus({ dispatch }) {
    return dispatch('fetchMenus')
  }
}

// 过滤可见菜单的辅助函数，同时收集首页快捷入口
function filterVisibleMenus(menus, quickEntriesCollector = []) {
  const targetNames = ['商品列表', '订单列表', '提现列表']

  return menus.filter(menu => menu.is_visible === 1).map(menu => {
    // 如果是目标菜单，收集到快捷入口数组中
    if (targetNames.includes(menu.menu_name)) {
      let name = menu.menu_name
      quickEntriesCollector.push({ ...menu, display_name: name })
    }

    // 如果有子菜单，递归过滤子菜单
    if (menu.children && menu.children.length > 0) {
      return {
        ...menu,
        children: filterVisibleMenus(menu.children, quickEntriesCollector)
      }
    }
    return menu
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}